/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mb-10[_ngcontent-%COMP%]{margin-bottom:10px!important}.text-ellipsis[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.list-group-item-nopadding[_ngcontent-%COMP%]{padding:0!important;border:none!important}"];
export { styles as styles };
